import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit
} from "@angular/core";
import { ApplicationMessageService } from "src/app/services/application-message.service";
import { IconService } from "src/app/services/icon.service";
import { ApplicationMessageTypeEnum } from "src/domain/client";

import { IconComponent } from "../icon/icon.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-application-messages",
  templateUrl: "./application-messages.component.html",
  imports: [IconComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationMessagesComponent implements OnInit {
  ApplicationMessageTypeEnum = ApplicationMessageTypeEnum;

  public applicationMessageService = inject(ApplicationMessageService);
  public iconService = inject(IconService);

  constructor() {}

  ngOnInit(): void {
    console.log("ApplicationMessagesComponent initialized");
    this.applicationMessageService.getApplicationMessages();
  }
}
